import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Header from "./components/Header";
import Hero from "./components/Hero";
import Sectors from "./components/Sectors";
import Gallery from "./components/Gallery";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import SiteAlert from "./components/SiteAlert"; 
import ScrollToTop from "./components/ScrollToTop";
// === vues détaillées ===
import PressureServiceView from "./views/PressureServiceView";
import PressureServiceformation from "./views/service_formation_acadymique";
import PressureServicelevage from "./views/Levage";
import MaritimeExpertiseView from "./views/maritime";
import ConstructionControlView from "./views/Controle _de_construction";
import ControlesNonDestructifsView from "./views/controles-non-destructifs";
import AscenseursMonteChargesView from "./views/ascenseurs-monte-charges";
import ControleTubesView from "./views/controle-tubes";
import ControleCablesView from "./views/controle-cables";
import ThermographieInfrarougeView from "./views/thermographie-infrarouge";
import InstallationsElectriquesView from "./views/installations-electriques";
import AssistanceTechniqueView from "./views/assistance-technique";
import "./App.css";

function App() {
  return (
    <Router>
      {/* ✅ bandeau affiché dès ouverture du site */}
      <SiteAlert />
   <ScrollToTop />   {/* ⬅️ Ajout ICI */}
      <Routes>
        {/* Page d'accueil */}
        <Route
          path="/"
          element={
            <>
              <Header/>
              <Hero />
              <div className="container">
                <Sectors />
                <Contact id="contact" />
              </div>
              <Footer />
            </>
          }
        />

        {/* === autres routes services === */}
        <Route path="/services/appareils-pression" element={<PressureServiceView />} />
        <Route path="/services/service_formation_acadymique" element={<PressureServiceformation />} />
        <Route path="/services/levage" element={<PressureServicelevage />} />
        <Route path="/services/expertise_maritime" element={<MaritimeExpertiseView />} />
        <Route path="/services/Controle_de_construction" element={<ConstructionControlView />} />
        <Route path="/services/controles-non-destructifs" element={<ControlesNonDestructifsView />} />
        <Route path="/services/ascenseurs-monte-charges" element={<AscenseursMonteChargesView />} />
        <Route path="/services/controle-tubes" element={<ControleTubesView />} />
        <Route path="/services/controle-cables" element={<ControleCablesView />} />
        <Route path="/services/thermographie-infrarouge" element={<ThermographieInfrarougeView />} />
        <Route path="/services/installations-electriques" element={<InstallationsElectriquesView />} />
        <Route path="/services/assistance-technique" element={<AssistanceTechniqueView />} />
      </Routes>
    </Router>
  );
}

export default App;
